import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAccessToken, setAccessToken } from '../utils/access-token-storage';
import api from '../api';

// 1. 登录，返回 token
export const login = createAsyncThunk(
    'auth/login',
    async (data, { rejectWithValue }) => {
        try {
            const res = await api.createAccessToken(data);
            return res.item;
        } catch (err) {
            return rejectWithValue(err.message || '登录失败');
        }
    }
);

// 2. 获取用户信息
export const fetchUser = createAsyncThunk(
    'auth/fetchUser',
    async (_, { rejectWithValue }) => {
        try {
            const user = await api.getCurrentUser();
            return user.item;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        token: getAccessToken(),
        loading: false,
        error: null,
        user: null,
    },
    reducers: {
        logout(state) {
            state.user = null;
            state.token = null;
        },
        setError(state, action) {
            state.error = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            // 登录
            .addCase(login.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(login.fulfilled, (state, action) => {
                state.loading = false;
                state.token = action.payload;
            })
            .addCase(login.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // 获取用户信息
            .addCase(fetchUser.pending, (state) => {
            })
            .addCase(fetchUser.fulfilled, (state, action) => {
                state.user = action.payload;
            })
            .addCase(fetchUser.rejected, (state, action) => {
            });
    },
});

export const { logout, setError } = authSlice.actions;
export default authSlice.reducer;